module.exports = __webpack_public_path__ + "static/media/help_3.8d9b8b14.png";